import request from "@/service";

//列表
export function feedbackPage(params) {
  return request({
    url: `/sys/feedback/suggest/page`,
    method: "get",
    params
  });
}

// 详情
export function feedbackInfo(uuid) {
  return request({
    url: `/sys/feedback/suggest/info/${uuid}`,
    method: "get"
  });
}

// 编辑
export function feedbackUpdate(data) {
  return request({
    url: `/sys/feedback/suggest/update`,
    method: "put",
    data
  });
}
